namespace $ { $mol_style_attach( "mol/filler/filler.view.css",
 "[mol_filler] {\n\ttext-align: start;\n\tpadding: var(--mol_gap_text);\n\tflex-shrink: 0;\n}\n"
) }